import { render, staticRenderFns } from "./drawingPagePop.vue?vue&type=template&id=ace248fe&scoped=true"
import script from "./drawingPagePop.vue?vue&type=script&lang=js"
export * from "./drawingPagePop.vue?vue&type=script&lang=js"
import style0 from "./drawingPagePop.vue?vue&type=style&index=0&id=ace248fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace248fe",
  null
  
)

export default component.exports